import Vue from 'vue'
import store from './store'

Vue.filter('formatDate', function (value) {
	if (!value) {
		return ''
	}
	let date
	if (typeof value.getDate !== 'function') {
		date = new Date(value)
	} else {
		date = value
	}
	let day = date.getDate()
	let month = date.getMonth() + 1
	let year = date.getFullYear()
	if (String(day).length === 1) {
		day = '0' + day
	}
	if (String(month).length === 1) {
		month = '0' + month
	}
	return day + '/' + month + '/' + year
})

Vue.filter('testAcl', function (acl) {
	return !acl || (!!store.getters.user && store.getters.user.acls.findIndex((el) => el.includes(acl)) !== -1)
})



// WEBPACK FOOTER //
// ./src/filters.js